<section class="col">
  <p-panel header="Filter">
    <p-card data-variant="fields">
      <div class="form-box">
        <label>{{ 'Service_Costs_Month' | translateWF: 'Month' }} *</label>
        <p-dropdown
          [formControl]="month"
          [options]="monthOptions"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'Service_Costs_Month' | translateWF: 'Month'"
          styleClass="w-full"
        />
      </div>
      <div class="form-box">
        <label>{{ 'Service_Costs_Year' | translateWF: 'Year' }} *</label>
        <p-dropdown
          [formControl]="year"
          [options]="yearOptions"
          optionLabel="label"
          optionValue="value"
          [placeholder]="'Service_Costs_Year' | translateWF: 'Year'"
          styleClass="w-full"
        />
      </div>
    </p-card>
  </p-panel>

  <p-panel header="Filter">
    <p-card data-variant="compact">
      <p-table [value]="rows" styleClass="service-costs-table" [loading]="isLoadingPeriod()">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ 'Service_Costs_Utility_Type' | translateWF: 'Utility Type' }}</th>
            <th>{{ 'Service_Costs_Invoice_No' | translateWF: 'Invoice No.' }}</th>
            <th>{{ 'Service_Costs_Currency' | translateWF: 'Currency' }}</th>
            <th>{{ 'Service_Costs_Value' | translateWF: 'Value' }}</th>
            <th>{{ 'Service_Costs_File' | translateWF: 'File' }}</th>
            <th style="width: 120px">{{ 'Service_Costs_Actions' | translateWF: 'Actions' }}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row>
          <tr>
            <td class="utility-type">
              <span>{{ row.label }}</span>
            </td>

            <td>
              <input
                pInputText
                type="text"
                [formControl]="row.invoiceNumber"
                placeholder="{{ 'Service_Costs_Invoice_No' | translateWF: 'Invoice No.' }}"
                class="w-full"
                [disabled]="month.value === null || year.value === null"
              />
            </td>

            <td>
              <p-dropdown
                [formControl]="row.currency"
                [options]="currencyOptions"
                optionLabel="label"
                optionValue="value"
                styleClass="w-full"
                [disabled]="month.value === null || year.value === null"
              />
            </td>

            <td>
              <p-inputNumber
                [formControl]="row.value"
                styleClass="w-full"
                [minFractionDigits]="2"
                [maxFractionDigits]="2"
                [min]="0.01"
                placeholder="0.00"
                [disabled]="month.value === null || year.value === null"
              />
            </td>

            <td>
              @if (row.file()) {
                <div class="file-selected">
                  <i class="pi pi-file mr-1"></i>
                  <span class="file-name" [pTooltip]="row.file()!.name">{{ row.file()!.name }}</span>
                  <p-button
                    icon="pi pi-times"
                    severity="secondary"
                    [rounded]="true"
                    [text]="true"
                    size="small"
                    (click)="clearFile(row)"
                    [pTooltip]="'Remove' | translateWF: 'Remove'"
                  />
                </div>
              } @else {
                <label class="file-upload-btn" [class.disabled]="month.value === null || year.value === null">
                  <i class="pi pi-upload mr-1"></i>
                  {{ 'Service_Costs_Attach' | translateWF: 'Attach' }}
                  <input
                    type="file"
                    class="hidden"
                    accept=".xlsx,.xls,.pdf,.png,.jpg,.jpeg"
                    [disabled]="month.value === null || year.value === null"
                    (change)="onFileChange(row, $event)"
                  />
                </label>
              }
            </td>

            <td>
              <div class="row-actions">
                <p-button
                  [label]="'Service_Costs_Save' | translateWF: 'Save'"
                  icon="pi pi-save"
                  [disabled]="!canSaveRow(row)"
                  [loading]="row.isSaving()"
                  (click)="saveRow(row)"
                  size="small"
                />
                @if (row.savedStatus() === 'success') {
                  <i class="pi pi-check-circle text-green-500 ml-2" [pTooltip]="'Service_Costs_Save_Success' | translateWF: 'Saved successfully'"></i>
                }
                @if (row.savedStatus() === 'error') {
                  <i class="pi pi-times-circle text-red-500 ml-2" [pTooltip]="row.errorMessage()"></i>
                }
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>

      @if (month.value === null || year.value === null) {
        <div class="hint-banner mt-3">
          <i class="pi pi-info-circle mr-2"></i>
          {{ 'Service_Costs_Hint_Select_Month_Year' | translateWF: 'Select month and year to enable data entry' }}
        </div>
      }
    </p-card>
  </p-panel>
</section>
